import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom'
import { NetworkProvider, useNetwork } from './components/NetworkContext';
import Home from './pages/Home';
import Landing from './pages/Landing';
import MapPage from './pages/MapPage';
import PositionDetails from './pages/PortfolioPage';
import Deployment from './pages/CreateBonds';
import MarketDetails from './pages/MarketPlacePage';
import USDCTestnetFaucetPage from './pages/USDCTestnetFaucetPage';

const ProtectedRoute = ({ element }) => {
  const { network } = useNetwork();
  return network ? element : <Navigate to="/" />;
};
const LandingRedirect = () => {
  const { network } = useNetwork();
  const navigate = useNavigate();

  useEffect(() => {

    if (network) {
      navigate('/map');
    }
  }, [network, navigate]);

  return <Landing />;
};

const App = () => {
  return (
    <NetworkProvider>

      <Router>
        <div className="app-container">
          <Routes>
            <Route path="/" element={<LandingRedirect />} />
            <Route path="/home" element={<ProtectedRoute element={<Home />} />} />
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/map" element={<ProtectedRoute element={<MapPage />} />} />
            <Route path="/create-bonds" element={<ProtectedRoute element={<Deployment />} />} />
            <Route path="/portfolio" element={<ProtectedRoute element={<PositionDetails />} />} />
            <Route path="/marketplace" element={<ProtectedRoute element={<MarketDetails />} />} />
            <Route path="/usdc-testnet-faucet" element={<ProtectedRoute element={<USDCTestnetFaucetPage />} />} />
          </Routes>
        </div>
      </Router>
    </NetworkProvider>
  );
};

export default App;
